import initialState from "../initialState";
import { sortByName } from "../sortEntities";

export const investigationStatuses = (state = initialState.investigationStatuses, action) => {
	switch (action.type) {
		case "LOAD_INVESTIGATION_STATUSES":
			return [...action.payload];

		case "LOAD_INVESTIGATION_STATUS":
			return state.map((ss) =>
				ss.id !== action.payload.id
					? ss
					: {
							...ss,
					  }
			);

		case "RENAME_INVESTIGATION_STATUS":
			return state
				.map((x) => (x.id !== action.payload.id ? x : { ...x, name: action.payload.name }))
				.sort(sortByName);

		case "CREATE_INVESTIGATION_STATUS":
			return [...state, action.payload].sort(sortByName);

		case "REMOVE_INVESTIGATION_STATUS":
			return state.filter((investigationStatus) => investigationStatus.id !== action.payload.id);

		default:
			return state;
	}
};

export default investigationStatuses;
